import { useQuery } from 'react-query';
import { getFormQuestionOption } from '../Forms/ApiForms';
import DropDown from './Components/DropDown';

export default function VisitorsList(props) {
  const { values, errors, setFieldValue, title, placeholder, dropData } = props;
  let visitorsListQueryinitialState = {
    typeId: 1,
    paginationFilter: {
      pageNumber: 1,
      pageSize: 99999,
      isPaging: false,
      langId: 0,
    },
  };

  const visitorsListQuery = useQuery(['formQuestionOption', visitorsListQueryinitialState], getFormQuestionOption, {
    staleTime: 99900,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
  return (
    <>
      {visitorsListQuery.isLoading && (
        <>
          <label className="relative col-span-2 lg:col-span-1 mb-4">
            <div className="block mb-2 py-4 w-1/2 text-lg font-semibold bg-white animate-pulse"></div>
            <div className="px-4 py-6 w-full bg-white rounded-md outline-none animate-pulse"></div>
          </label>
        </>
      )}
      {visitorsListQuery.data && (
        <DropDown
          title={title}
          placeholder={placeholder}
          list={visitorsListQuery.data.data}
          loading={visitorsListQuery.loading}
          error={visitorsListQuery.error}
          values={values}
          errors={errors}
          disabled={false}
          setFieldValue={setFieldValue}
          FieldValue={values.visitors}
          dropData={dropData}
          FieldName="visitors"
        />
      )}
    </>
  );
}
